import {html} from 'lit';
import componentStyles from './video-youtube.css.lit.ts';
import {OutlineElement} from '../../base/outline-element/outline-element.ts';

export default class YouTubeVideo extends OutlineElement {
  static styles = [super.styles, componentStyles];

  static get properties() {
    return {
      id: {type: String},
    };
  }

  constructor() {
    super();
    this.id = ''
    this.url = ''
    this.title = ''
    this.firedProgressEvent = {
      10: false,
      25: false,
      50: false,
      75: false,
      90: false,
    }
  }

  setTitle(title) {
    this.title = title
  }

  setPlayer(player) {
    this.player = player
  }

  getPlayer() {
    return this.player
  }

  onPlayerReady(event) {
    const host = event.target.i.getRootNode().host
    const video_data = event.target.getVideoData();
    host.setTitle(video_data.title)
  }

  getProgress(event) {
    if (!event.target) {
      return 0;
    }

    const getDuration = event.target.getDuration();
    const getCurrentTime = event.target.getCurrentTime();
    return Math.round(getCurrentTime / getDuration * 100)
  }

  onPlayerStateChange(event) {
    const host = event.target.i.getRootNode().host

    switch(event.data) {
      case YT.PlayerState.PLAYING:
        host.handleEvent(event, host, 'play')
        break;
      case YT.PlayerState.ENDED:
        host.handleEvent(event, host, 'ended')
        break;
      case YT.PlayerState.PAUSED:
        host.handleEvent(event, host, 'pause')
        break;
    }
  }

  onYouTubeIframeAPIReady(event) {
    const youtubeElements = document.querySelectorAll('hf-video-youtube:not(.processed)');
    youtubeElements.forEach(
      (node) => {
        node.classList.add('processed')
        const wrapper = node.shadowRoot.querySelector('.video--youtube');
        const videoId = wrapper.getAttribute('data-id')
        const player = new YT.Player(wrapper, {
          videoId: videoId,
          playerVars: {
            'playsinline': 1
          },
          events: {
            'onReady': node.onPlayerReady,
            'onStateChange': node.onPlayerStateChange
          }
        });

        node.setPlayer(player);
      }
    );
  }

  addScript() {
    let tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";

    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  formatEventName(eventName) {
    if (eventName === 'ended') {
      return "Complete";
    } else {
      return eventName.charAt(0).toUpperCase() + eventName.slice(1)
    }
  }

  needProgressEvent(data) {
    const currentProgress = this.getProgress(data)
    const progressValueToSend = Object.keys(this.firedProgressEvent).find((key) => this.firedProgressEvent[key] === false);

    if (!progressValueToSend) {
      return false;
    }

    if (currentProgress >= progressValueToSend) {
      this.firedProgressEvent[progressValueToSend] = true;
      return progressValueToSend;
    }

    return false;
  }

  startTimer(event, host) {
    host.timer = setInterval(() => {
      host.handleEvent(event, host, 'progress')
    }, 1000);
  }

  stopTimer(event, host) {
    clearInterval(host.timer);
  }

  handleEvent(event, host, eventName) {
    const data = {
      percent: host.getProgress(event)
    }

    if (eventName === 'play') {
      host.startTimer(event, host)
    } else if (eventName === 'pause' || eventName === 'ended') {
      host.stopTimer(event, host)
    }

    host.fireEvent(eventName, data, host, event)
  }

  fireEvent(eventName, data, host, event) {
    const needToSendProgressValue = eventName === 'progress' ? this.needProgressEvent(event) : true
    const dataLayerData = {
      videoTitle: this.title,
      videoSource: this.url,
      videoAction: this.formatEventName(eventName),
      Progress: eventName === 'progress' ? needToSendProgressValue : this.getProgress(event)
    };

    if (eventName !== 'progress' || needToSendProgressValue) {
      window.dispatchEvent(
        new CustomEvent
        (
          'hf-video-gtm-event',
          {
            detail: {
              dataLayerData,
            },
          }
        )
      );
    }
  }

  firstUpdated() {
    this.url = `https://www.youtube.com/embed/${this.id}`

    if (typeof YT === 'undefined') {
      this.addScript();
    }

    window.youtubeFrames = [];
    window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady;
  }

  render() {
    return html`
      <div class="video video--youtube" id="video-youtube" data-id="${this.id}">
      </div>`;
  }
}

customElements.define('hf-video-youtube', YouTubeVideo);
